import { isDevMode } from "@angular/core";

export const SAAS_URL_FILTER = 'saas_url_filter';
export const SAAS_DNS_FILTER = 'saas_dns_filter';
export const SAAS_APP_DETECTION = 'saas_app_detection';
export const LOG_CONNECTOR = 'log_connector';
export const CAMPUS = 'campus';
export const SUPPORT = 'support';
export const FEATURE_TOGGLE = 'feature_toggle';

export const GRANTED_ROLES = ['admin' ,'adminless'];
export const ADMIN_LESS = ['admin', 'adminless'];
export const ADMIN = ['admin'];

export function enableFeatureToggle(token: string): string {
  return isDevMode() ? token : FEATURE_TOGGLE;
}
